import PilotosPage from './page';
// import ClientForm from './clientForm';
// import PanelClient from './panelClient';

// export { ClientForm, PanelClient };
export default PilotosPage;
